/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

loadStyles([{"rawString":".PropertiesTable{margin-bottom:20px;overflow-x:auto;overflow-y:inherit}.PropertiesTable-noProperties{background:"},{"theme":"yellow","defaultValue":"#ffb900"},{"rawString":";padding:10px}.PropertiesTable-nameCell{color:"},{"theme":"themePrimary","defaultValue":"#0078d7"},{"rawString":"}"}]);
/* tslint:enable */